module.exports = __webpack_public_path__ + "static/img/company4.52b2077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company4.png
// module id = 6qAS
// module chunks = 1